import { styled } from 'styled-components';
import { Close as DialogClose } from '@radix-ui/react-dialog';
import { Icon } from '../Icon';
import { IconButton } from '../IconButton';

const CloseButton = styled(DialogClose)`
  align-self: start;
`;

export const ModalCloseButton = () => {
  return (
    <CloseButton asChild={true}>
      <IconButton
        label="Dismiss modal"
        size="sm"
        variant="ghost"
      >
        <Icon type="close" />
      </IconButton>
    </CloseButton>
  );
};
